export const configuratorSelector = (state) => state.configurator;
